module.exports = __webpack_public_path__ + "img/Logo.4a0e28b3.png";